
    import _ from 'lodash';
    import {Component, Vue, Watch} from 'vue-property-decorator';
    import Api, { ApiRepository } from '@/api';
    import InputText from '@/components/form/Input-text.vue';
    import Layout from '@/components/layout/Layout.vue';
    import Table from '@/components/table/Table.vue';
    import { IApplicationsCount } from "@/models/ApplicationsCount";
    import router from "@/router";

    @Component({
        components: {
            InputText,
            Layout
        },
    })

    export default class PartnerEdit extends Vue {
        private partner: any = {};
        private originalName: string = '';
        private newPartner = false;

        public async mounted() {
            let partnerId = this.$route.params.partner;

            if (partnerId) {
                this.partner = await ApiRepository.getPartner(partnerId);
                this.originalName = this.partner.name;
            } else {
                this.newPartner = true;
                this.originalName = 'Nový partner';
            }
        }

        private async onSubmit(event: any) {
            event.preventDefault();
            this.$validator.validate().then((valid) => {
                if (valid) {
                    if (this.newPartner) {
                        ApiRepository.createPartner({
                            email: this.partner.email,
                            name: this.partner.name,
                        })
                    } else {
                        ApiRepository.editPartner(this.partner.id, {
                            email: this.partner.email,
                            name: this.partner.name,
                        })
                    }
                }
            });
        }
    }
